import { render, staticRenderFns } from "./NLItemEditN2.vue?vue&type=template&id=60729956&"
import script from "./NLItemEditN2.vue?vue&type=script&lang=js&"
export * from "./NLItemEditN2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports